import type { ExchangeBetslipCapabilities, SportsbookBetslipCapabilities } from "../../../contract";

export const BETSLIP__SBK_CAPABILITIES_RECEIVED = "BETSLIP/SBK_CAPABILITIES_RECEIVED";
export const BETSLIP__EXC_CAPABILITIES_RECEIVED = "BETSLIP/EXC_CAPABILITIES_RECEIVED";

export type SportsbookCapabilitiesReceivedAction = {
  type: typeof BETSLIP__SBK_CAPABILITIES_RECEIVED;
  payload: SportsbookBetslipCapabilities;
};

export type ExchangeCapabilitiesReceivedAction = {
  type: typeof BETSLIP__EXC_CAPABILITIES_RECEIVED;
  payload: ExchangeBetslipCapabilities;
};
